import React, {Component, Fragment, useEffect, useState} from 'react'
import DonationButton from "../components/donation-button";

export default function FixedBar(props){

    const isMobile=props.context.isMobile

    if(!isMobile){
        return null
    }

    return(
        <div className={"bar"} style={{
            width:"100%",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            position:"fixed",
            bottom:"-0rem",
            padding:"0.5rem",
            zIndex:200,
        }}>
           <DonationButton {...props} onClick={()=>{
               document.getElementById('block-don').scrollIntoView({
                   behavior: 'smooth'
               });
               document.getElementById("montant").focus();
           }}/>
        </div>
    )
}
